import React from 'react'

const Contact = () => {
  return (
    <section id='contact' className='max-w-contentContainer mx-auto py-10 xl:py-32 flex flex-col gap-4 items-center justify-center'>
        <h2 className='font-titleFont text-5xl font-semibold'>
            Get In Touch
        </h2>
        <p className='font-titleFont text-lg text-textGreen font-semibold flex items-center tracking-wide'>
            Can't wait to hear from you today!
        </p>
        <p className='max-w-[600px] text-center text-textDark'>
            Please feel free to send feedbacks and suggestions. I am always open to discussions. &#x1F680;
        </p>
        <a href='mailto:bunmidavids194@gmail.com'>
            <button className='w-40 h-14 border border-textGreen mt-6 font-titleFont text-sm text-textGreen tracking-wider rounded-md hover:bg-hoverColor duration-300'>
                Send a mail
            </button>
        </a>
    </section>
  )
}

export default Contact